import ProhibitedCategories from "@/config/prohibited-categories.json";





export function getProhibitedCategoryLabel(value: string){
    return ProhibitedCategories.find(p => p.value === value)?.label ?? "";
  }


export function getProhibitedCategories(): Record<string, any>[] {
  return ProhibitedCategories.filter(p => !p.hide);
}